import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { authClient } from '@/lib/auth-client';

export const Route = createFileRoute('/_public')({
  beforeLoad: async ({ location }) => {
    const session = await authClient.getSession({
      fetchOptions: { credentials: 'include' },
    });
    if (session.data) {
      // If visiting signup with an invitation token, sign out first
      // so the invited user can create their account
      if (location.pathname === '/signup' && location.searchStr?.includes('token=')) {
        await authClient.signOut({ fetchOptions: { credentials: 'include' } });
        return;
      }
      throw redirect({ to: '/' });
    }
  },
  pendingComponent: () => (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-muted-foreground">Loading...</div>
    </div>
  ),
  component: Outlet,
});
